/** @jsxImportSource @emotion/react */

import { FC } from 'react'
import IconButton from '@mui/material/IconButton'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow.svg'
import * as classes from './styles'

type Props = {
  className?: string
  onPrevClick?: (() => void) | null
  onNextClick?: (() => void) | null
}

export const ChartActions: FC<Props> = ({ className, onPrevClick, onNextClick }) => (
  <div css={classes.buttonsWrapper} className={className}>
    <IconButton css={[classes.arrowButton]} disabled={!onPrevClick} onClick={onPrevClick || undefined}>
      <ArrowIcon />
    </IconButton>
    <IconButton css={[classes.arrowButton]} disabled={!onNextClick} onClick={onNextClick || undefined}>
      <ArrowIcon />
    </IconButton>
  </div>
)
